import { List } from 'react-admin';
import { AdsJobsDataGrid } from './AdsJobsDataGrid';
import { TablePagination } from '../../../helperComponents/TablePagination';
import { TitleAboveTable } from '../../../helperComponents/TitleAboveTable';
import { ToolBarRowStyleToggle } from '../../../helperComponents/ToolBarRowStyleToggle';
import { getAdsJobsFilters } from './helpers/adsJobsFilters';

export const AdsJobsList = (props) => {
  return (
    <>
      <TitleAboveTable title="Jobs" />
      <List
        {...props}
        title=" "
        actions={<ToolBarRowStyleToggle showSelectColumnsButton showExportButton={false} />}
        pagination={<TablePagination />}
        filters={getAdsJobsFilters()}
        sort={{ field: 'priority', order: 'ASC' }}
      >
        <AdsJobsDataGrid />
      </List>
    </>
  );
};
